import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from "../combos/SchoolCombo";
import { Col, Form, Row } from 'react-bootstrap';



export default function SchoolManagerSetPassword(props) {
    const toast = useRef(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [school, setSchool] = useState({});
    const [nationalId, setNationalId] = useState("");


    useEffect(() => {
    }, []);
    const checkDataEntry = function(){
      if(school == null){
            setErrorMessage("مدرسه را انتخاب نمائید");
            setErorVisible(true);
            return false;
      }
      if(!school.id){
            setErrorMessage("مدرسه را انتخاب نمائید");
            setErorVisible(true);
            return false;
      }
      if(school.id == ""){
            setErrorMessage("مدرسه را انتخاب نمائید");
            setErorVisible(true);
            return false;
      }
      if(nationalId.trim().length == 0){
          setErrorMessage("کد ملی مدیر را وارد کنید");
          setErorVisible(true);
          return false;
      } 

      return true;
    }

    const saveItem = function(isActive){
      if(!checkDataEntry()) return;
      setSaving(true);
      var params = {login:util.getTrustedUser(), organizationCode:school.itemValue.organizationCode, nationalId:nationalId};
      var url = config.Server+`/user/school/manager/reset-password`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log(school.itemValue.organizationCode)
              if(response.state === "ok"){
                response = response.data;
                setNationalId("");                
                setSaving(false);
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'رمز مدیر به شماره موبایل ایشان تنظیم گردید' });
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const onComboChange = function(name, value){
      if(name == 'school'){
        console.log(school)
        setSchool(value);
        return
      }
    }
    return(      
      <>
    <Row style={{marginTop:"20px"}} className='justify-content-center'>
      <Col md={4} style={{}}>
        <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>بازسازی کلمه عبور مدیر مدرسه</div>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col>
            <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={false} value={school} onChange={(val) => onComboChange('school', val)} />
          </Col>
        </Row>
        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col>
              <FloatLabel>
                <InputText value={nationalId} onChange={(e) => setNationalId(e.target.value)} keyfilter="" maxLength={10} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                <label htmlFor="username">کد ملی مدیر</label>
              </FloatLabel>
          </Col>
        </Row>
        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col md={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="بازسازی کلمه عبور به شماره موبایل" icon="pi pi-check" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} />                    
            </div>
          </Col>
        </Row>


        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
      </Col>
    </Row>   
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
